import S from './PrivacyTerms.module.scss';
const _PrivacyTerms = () => {
  return <></>;
};
const Section = (props: {
  data: string;
}) => {
  return <div className={S.section} data-sentry-component="Section" data-sentry-source-file="PrivacyTerms.tsx">
      <div dangerouslySetInnerHTML={{
      __html: props.data
    }} />
    </div>;
};
export const PrivacyTerms = Object.assign(_PrivacyTerms, {
  Section
});